import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-exercise-referral',
  templateUrl: './exercise-referral.component.html',
  styleUrls: ['./exercise-referral.component.scss']
})
export class ExerciseReferralComponent implements OnInit {



  @Input('learner') learnerData;
  @Input('job') singleJob;
  @Input('assessment') assessmentPlanEdit;
  singleLearner: any;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  user
  constructor() { }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }




  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue._id
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobId = changes.singleJob.currentValue
    }

    // if (changes.summarySheetEdit && changes.summarySheetEdit.currentValue) {
    //     this.summarySheetEdit = changes.summarySheetEdit.currentValue
    // }

    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

    }
  }

}
